import { useRef, useState } from 'react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import './carousal.css'
import { SlideContent } from './carousal.types'
import SlideImage from './slide-image'
import SlideVideo from './slide-video'

interface CarousalProps {
  contents: SlideContent[]
  showVideos?: boolean
  navigation?: boolean
  carousalStyles?: string
  slideStyles?: string
  hideControlBars?: boolean
  slideFullWidth?: boolean
}

/**
 * Caoursal can display videos and images.
 * ! We are using VideoPlay for video slides.
 * ? How to disable video player controls
 * @param {CarousalProps} contents
 */
export default function Carousal({
  contents,
  slideStyles,
  carousalStyles,
  showVideos = false,
  navigation = false,
  slideFullWidth = false,
  hideControlBars = false,
}: CarousalProps) {
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(0)

  /**
   - import {PlayerReference} from 'video-react' will be used as a type for useRef of feedItemRef
   - right now we are using any for the flow.
  */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const feedItemRef = useRef<any>(null)
  feedItemRef.current = []

  return (
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      loop={true}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      allowTouchMove={!showVideos}
      simulateTouch={!showVideos}
      touchStartPreventDefault={!showVideos}
      pagination={{
        clickable: true,
      }}
      navigation={navigation}
      modules={[Autoplay, Pagination, Navigation]}
      className={`${carousalStyles} mySwiper cursor-pointer`}
      onSlideChange={() => {
        if (showVideos && feedItemRef.current[currentVideoIndex]) {
          feedItemRef.current[currentVideoIndex].pause()
          setCurrentVideoIndex(0)
        }
      }}
    >
      {contents
        .filter((content) => content.mediaType)
        ?.map((content, index) => (
          <SwiperSlide
            className={slideStyles}
            key={`${index}-${content.campaignContentId}`}
          >
            {content.mediaType === 'video' ? (
              <SlideVideo
                index={index}
                fullWidth={slideFullWidth}
                content={content}
                showVideos={showVideos}
                feedItemRef={feedItemRef}
                hideControlBars={hideControlBars}
                setCurrentVideoIndex={setCurrentVideoIndex} />
            ) : (
              <SlideImage content={content} />
            )}
          </SwiperSlide>
        ))}
    </Swiper>
  )
}
